// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsProductLine__container,.NsProductLine__left,.NsProductLine__right{position:relative;display:flex;align-items:center}.NsProductLine__container{color:#272525;width:100%}.NsProductLine__left>*,.NsProductLine__right>*{margin-left:15px}.NsProductLine__left{flex:1}.NsProductLine__right>*:last-child{margin-right:15px}.NsProductLine__product-image{max-height:38px;max-width:38px}.NsProductLine__product-title{font-size:13px;font-weight:normal}", ""]);
// Exports
exports.locals = {
	"container": "NsProductLine__container",
	"left": "NsProductLine__left",
	"right": "NsProductLine__right",
	"product-image": "NsProductLine__product-image",
	"product-title": "NsProductLine__product-title"
};
module.exports = exports;
